
export const basepath = 'http://test.res.jsvry.com/krpano/';
export const wwwUrl = 'https://www.jsvry.com';